import { render } from "./FormAction.vue?vue&type=template&id=0c72e06a&scoped=true&ts=true"
import script from "./FormAction.vue?vue&type=script&lang=ts"
export * from "./FormAction.vue?vue&type=script&lang=ts"

import "./FormAction.vue?vue&type=style&index=0&id=0c72e06a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c72e06a"]])

export default __exports__